export default __webpack_public_path__ + "static/media/back.ca98f94c.svg";